<template>
  <div id="robot">
    <div class="robot_banner"></div>
    <div class="container">
      <div class="home_item_content">
        <h6>Function display</h6>
        <i></i>
        <h1>功能展示</h1>
        <p>一毛共享新零售智能安防机器人是远达智能科技全新开发的一款多功能机器人。相当于一个集影音娱乐学习、智能贩卖、智能安防功能为一体的智能自动售货机。</p>
      </div>
    </div>
    <div class="container">
      <ul class="robot_detail">
        <li :class="{activeColor:isActive1}">
          <h5>头部（电子屏）</h5>
          <p>机器人头部的电子屏植入了影音娱乐系统，可以满足您随时随地看电影、视频教学、学习、点歌、甚至K歌等功能</p>
          <div class="img_line1" v-show="isActive1">
            <img src="../../assets/images/robot_led.png" alt />
          </div>
        </li>
        <li :class="{activeColor:isActive2}">
          <h5>头部（两个麦克风）</h5>
          <p>机器人头部植入了两个麦克风，在您需要进行学习时，可以自动进行语音识别，满足您学习、语音输入的需求。</p>
          <div class="img_line2" v-show="isActive2">
            <img src="../../assets/images/robot_mike.png" alt />
          </div>
        </li>
        <li :class="{activeColor:isActive3}">
          <h5>头部（全景摄像头）</h5>
          <p>机器人头部植入了隐藏式的全景摄像头，摄像头与公安系统联网，当机器人在室内时，该摄像头是隐藏的，不执行任何的功能；当机器人在室外时，全景摄像头就会开始工作，充分发挥安防监控的功能。</p>
          <div class="img_line3" v-show="isActive3">
            <img src="../../assets/images/robot_camera.png" alt />
          </div>
        </li>
        <li :class="{activeColor:isActive4}">
          <h5>后脑勺（投影仪）</h5>
          <p>机器人的后脑勺相当于一个投影仪，当机器人在户外没有工作时，就会自动寻找一面墙，进行投影）</p>
          <div class="img_line4" v-show="isActive4">
            <img src="../../assets/images/robot_projector.png" alt />
          </div>
        </li>
        <li :class="{activeColor:isActive5}">
          <h5>两个手臂（两个音响）</h5>
          <p>机器人的两只手臂，相当于两个音响，可以完美地配合机器人的影音、娱乐、学习等功能的实现。</p>
          <div class="img_line5" v-show="isActive5">
            <img src="../../assets/images/robot_hand.png" alt />
          </div>
        </li>
        <li :class="{activeColor:isActive6}">
          <h5>肚子（售货机）</h5>
          <p>机器人的肚子，相当于一个自动售货机，装满了可以零售的物品，可以实现自动送货、送餐、送快递等需求。</p>
          <div class="img_line6" v-show="isActive6">
            <img src="../../assets/images/robot_main.png" alt />
          </div>
        </li>
        <li :class="{activeColor:isActive7}">
          <h5>两个脚(两个轮子)</h5>
          <p>机器人的两个脚，相当于两个智能电动的轮子，可以支撑机器人在一定的区域范围内走动)。</p>
          <div class="img_line7" v-show="isActive7">
            <img src="../../assets/images/robot_foot.png" alt />
          </div>
        </li>
      </ul>
      <div class="robot_img">
        <div
          class="robot_img_1"
          ref="robot_img_1"
          @mouseover="hand_hover"
          @mousemove="hand_move($event)"
          @mouseleave="hand_out"
        >
          <img ref="hand" v-show="showHand" src="../../assets/images/robot_hover_hand.png" alt />
          <div class="camera" @click="click_camera">
            <img v-show="isActive3" src="../../assets/images/robot_cusor.png" alt />
          </div>
          <div class="projector" @click="click_projector">
            <img v-show="isActive4" src="../../assets/images/robot_cusor.png" alt />
          </div>

          <div class="head_box">
            <div class="mike" @click="click_mike">
              <img v-show="isActive2" src="../../assets/images/robot_cusor.png" alt />
            </div>
            <div class="led" @click="click_led">
              <img v-show="isActive1" src="../../assets/images/robot_cusor.png" alt />
            </div>
            <div class="mike" @click="click_mike">
              <img v-show="isActive2" src="../../assets/images/robot_cusor.png" alt />
            </div>
          </div>
          <div class="hands_box">
            <div class="hand" @click="click_hand">
              <img v-show="isActive5" src="../../assets/images/robot_cusor.png" alt />
            </div>
            <div class="main" @click="click_main">
              <img v-show="isActive6" src="../../assets/images/robot_cusor.png" alt />
            </div>
            <div class="hand" @click="click_hand">
              <img v-show="isActive5" src="../../assets/images/robot_cusor.png" alt />
            </div>
          </div>
          <div class="foot" @click="click_foot">
            <img v-show="isActive7" src="../../assets/images/robot_cusor.png" alt />
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <div class="box">
        <ul class="wulian_toggle" ref="ulParent">
          <li class="wulian_p1">
            <img src="../../assets/images/robot_1.png" alt />
            <div class="wulian_txt">
              <h3>火锅机器人</h3>
              <p>火锅机器人的肚子里配置有各种火锅配菜，您可以通过远程点单，实现对火锅机器人的操控，由机器人提供全套的包括锅底、餐具、配菜等的配送，同时提供全流程的火锅蒸煮服务，通过一键实现火锅美味抵达您的舌尖。</p>
            </div>
          </li>
          <li class="wulian_p2">
            <img src="../../assets/images/robot_2.png" alt />
            <div class="wulian_txt p2">
              <h3>
                木工机器人
                <span>(木工工具、钳工工具)</span>
              </h3>
              <p>工具机器人的肚子里配置有各种木工工具、钳工工具，您可以通过远程呼叫，实现对工具机器人的操控，让机器人完成对您所需工具的配送，满足您户外工作、游乐的不时之需。</p>
            </div>
          </li>
          <li class="wulian_p2">
            <img src="../../assets/images/robot_3.png" alt />
            <div class="wulian_txt p2">
              <h3>助手机器人</h3>
              <p>助手机器人主要满足您外出时的生活帮助需求，例如提取重物、旅游拍照等。您可以通过对助手机器人的操控，让机器人满足您在各个场景下的帮助需求。</p>
            </div>
          </li>
          <li class="wulian_p2">
            <img src="../../assets/images/robot_4.png" alt />
            <div class="wulian_txt p2">
              <h3>送餐机器人</h3>
              <p>送餐机器人的肚子里配置有所有外卖的餐饭，完全可以取代送餐员，实现高效快捷送餐。</p>
            </div>
          </li>
          <li class="wulian_p2">
            <img src="../../assets/images/robot_5.png" alt />
            <div class="wulian_txt p2">
              <h3>送快递机器人</h3>
              <p>送快递机器人的肚子里配置有所有取件人的快递，完全可以取代快递员，实现高效快捷送件。</p>
            </div>
          </li>
          <li class="wulian_p2">
            <img src="../../assets/images/robot_1.png" alt />
            <div class="wulian_txt p2">
              <h3>火锅机器人</h3>
            </div>
          </li>
          <li class="wulian_p2">
            <img src="../../assets/images/robot_2.png" alt />
            <div class="wulian_txt p2">
              <h3>
                木工机器人
                <span>(木工工具、钳工工具)</span>
              </h3>
            </div>
          </li>
        </ul>
        <div class="toggle_tab">
          <p>
            <span class="bigNum">0{{num+1}}</span>
            <span class="smallNum">/05</span>
          </p>
          <div class="bar">
            <div class="bar_in" ref="bar_in"></div>
          </div>
          <div class="wulian_btn">
            <a href="javascript:;" @click="backPage">
              <img src="../../assets/images/left.png" alt />
            </a>
            <a href="javascript:;" @click="gotoPage">
              <img src="../../assets/images/right.png" alt />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { log } from "util";
export default {
  components: {},
  props: {},
  data() {
    return {
      num: 0,
      right: 0,
      left: 0,
      isActive1: false,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      isActive5: false,
      isActive6: false,
      isActive7: false,
      showHand: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    gotoPage() {
      var i = 0;
      var ul = this.$refs.ulParent;
      var Lis = this.$refs.ulParent.getElementsByTagName("li");
      var bar_in = this.$refs.bar_in;
      for (i = 0; i < Lis.length; i++) {
        Lis[i].className = "wulian_p2";
      }
      if (this.num < 4) {
        this.num += 1;
        this.right += 358;
        this.left += 32;
        ul.style.right = this.right + "px";
        bar_in.style.left = this.left + "px";
        Lis[this.num].className = "wulian_p1";
      } else {
        this.num = 0;
        Lis[this.num].className = "wulian_p1";
        ul.style.right = 0;

        bar_in.style.left = 0;
        this.right = 0;
        this.left = 0;
        this.num = 0;
      }
    },
    backPage() {
      var i = 0;
      var ul = this.$refs.ulParent;
      var Lis = this.$refs.ulParent.getElementsByTagName("li");
      var bar_in = this.$refs.bar_in;
      if (0 < this.num) {
        for (i = 0; i < Lis.length; i++) {
          Lis[i].className = "wulian_p2";
        }
        this.num -= 1;
        this.right -= 358;
        this.left -= 32;
        ul.style.right = this.right + "px";
        bar_in.style.left = this.left + "px";
        Lis[this.num].className = "wulian_p1";
      } else {
        this.num = 0;
        Lis[this.num].className = "wulian_p1";
      }
    },

    click_led() {
      this.isActive1 = !this.isActive1;
    },
    click_mike() {
      this.isActive2 = !this.isActive2;
    },
    click_camera() {
      this.isActive3 = !this.isActive3;
    },
    click_projector() {
      this.isActive4 = !this.isActive4;
    },
    click_hand() {
      this.isActive5 = !this.isActive5;
    },
    click_main() {
      this.isActive6 = !this.isActive6;
    },
    click_foot() {
      this.isActive7 = !this.isActive7;
    },
    hand_hover() {
      this.showHand = true;
    },

    hand_move($event) {
      this.showHand = true;
      var offsetTop =
        this.$refs.robot_img_1.getBoundingClientRect().top +
        document.documentElement.scrollTop;
      var x =
        $event.pageX -
        this.$refs.robot_img_1.getBoundingClientRect().left -
        this.$refs.hand.offsetWidth / 2;
      var y = $event.pageY - offsetTop;

      this.$refs.hand.style.left = x + "px";
      this.$refs.hand.style.top = y + "px";
    },
    hand_out() {
      this.showHand = false;
    },
  },

  created() {},
  mounted() {
    this.interval = setInterval(() => {
      this.gotoPage();
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
<style lang="less" scoped>
#robot {
  width: 100%;
  height: 2700px;
  .robot_banner {
    background: url("../../assets/images/robot_banner.png") no-repeat;
    background-position: center;
    height: 500px;
    position: relative;
    top: 90px;
    margin-bottom: 90px;
    min-width: 1200px;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    .home_item_content {
      h6 {
        font-size: 14px;
        line-height: 20px;
        text-transform: uppercase;
        padding-top: 120px;
      }
      i {
        display: block;
        height: 4px;
        width: 40px;
        background: rgba(38, 172, 255, 1);
        margin: 8px 0;
      }
      h1 {
        font-size: 36px;
        line-height: 50px;
        font-weight: 500;
      }
      p {
        font-size: 14px;
        line-height: 20px;
        margin-top: 20px;
      }
    }
  }
}
.container {
  position: relative;
  .robot_img {
    position: absolute;
    top: 0;
    right: 0;
    background: url("../../assets/images/robot_dec.png") no-repeat;
    width: 863px;
    height: 1063px;
    background-position: left;
    background-size: cover;

    .robot_img_1 {
      background: url("../../assets/images/robot_img.png") no-repeat;
      position: absolute;
      width: 408px;
      height: 500px;
      top: 280px;
      right: 96px;
      img {
        position: absolute;
      }
      .camera {
        position: relative;
        width: 54px;
        height: 54px;
        margin: 0 auto;
        &:hover {
        }
        img {
          margin-top: -10px;
        }
      }
      .projector {
        width: 100px;
        height: 50px;
        margin: 5px auto 0;
        position: relative;
        img {
          margin-left: 20px;
        }
      }
      .head_box {
        justify-content: center;
        display: flex;
        .mike {
          width: 30px;
          height: 75px;
          position: relative;
          img {
            margin-left: -10px;
          }
        }
        .led {
          width: 170px;
          height: 75px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .hands_box {
        justify-content: space-between;
        display: flex;
        margin-top: 20px;
        .hand {
          margin-top: 20px;
          height: 130px;
          width: 80px;
          position: relative;
          display: flex;
          align-items: flex-end;
        }
        .main {
          height: 180px;
          width: 180px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .foot {
        width: 250px;
        height: 80px;
        margin: 30px auto 0;
        position: relative;
        img {
          margin-top: 20px;
        }
      }
    }
  }

  .robot_detail {
    margin-top: 60px;

    li {
      position: relative;
      z-index: 100;
    }
    .activeColor {
      color: rgba(38, 172, 255, 1);
      width: 550px;
    }
    .img_line1 {
      position: absolute;
      right: -288px;
      top: 64px;
    }
    .img_line2 {
      position: absolute;
      right: -258px;
      top: 76px;
    }
    .img_line3 {
      position: absolute;
      right: -357px;
      top: 0;
    }
    .img_line4 {
      position: absolute;
      right: -357px;
      top: -107px;
    }
    .img_line5 {
      position: absolute;
      right: -186px;
      top: -23px;
    }
    .img_line6 {
      position: absolute;
      right: -320px;
      top: -175px;
    }
    .img_line7 {
      position: absolute;
      right: -310px;
      top: -235px;
    }
    li {
      padding: 20px;
      margin-bottom: 30px;
      width: 500px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
      h5 {
        font-size: 16px;
        line-height: 28px;
      }
      p {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  .box {
    position: relative;
    overflow: hidden;

    .toggle_tab {
      position: absolute;
      bottom: 88px;
      left: 510px;
    }
  }
  .wulian_toggle {
    display: flex;
    margin-top: 160px;
    position: relative;
    // transition: all 0.3s;
    right: 0;

    .p2 p {
      margin-top: 25px;
    }
    .wulian_txt {
      padding: 30px;
      height: 85px;

      h3 {
        font-size: 20px;
        line-height: 24px;
        margin-bottom: 10px;
        span {
          font-size: 16px;
          line-height: 14px;
        }
      }
      p {
        font-size: 14px;
        line-height: 24px;
      }
    }
    .wulian_p1 {
      height: 527px;
      width: 486px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(222, 222, 222, 1);
      box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
      flex-shrink: 0;
    }
    .wulian_p2 {
      width: 333px;
      height: 318px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(222, 222, 222, 1);
      flex-shrink: 0;
      margin-left: 24px;
      overflow: hidden;
      img {
        width: 100%;
        height: 240px;
      }
    }
  }
  .toggle_tab {
    display: flex;
    align-items: center;
    .bar {
      width: 160px;
      height: 4px;
      background: rgba(222, 222, 222, 1);
      opacity: 1;
      border-radius: 2px;
      margin: 0 30px;
      position: relative;
      .bar_in {
        width: 32px;
        height: 4px;
        background: rgba(38, 172, 255, 1);
        opacity: 1;
        border-radius: 2px;
        position: absolute;
      }
    }
    .bigNum {
      font-size: 28px;
      font-family: DIN;
      font-weight: 400;
      line-height: 53px;
      color: #333333;
    }
    .smallNum {
      font-size: 16px;
      font-family: DIN;
      font-weight: 400;
      line-height: 53px;
      color: rgba(153, 153, 153, 1);
    }
  }
  .wulian_btn {
    img {
      z-index: 10;
      border: 0 none;
    }
    a {
      padding: 20px;

      &:hover {
        background: rgba(38, 172, 255, 0.1);
      }
    }
  }
}
</style>